import { setupLocale } from "survey-core";

//On behalf of @kleinfelderm (https://github.com/kleinfelderm)

export var haitianCreoleStrings = {
  pagePrevText: "Anvan",
  pageNextText: "Pwochen",
  completeText: "Ranpli",
  previewText: "Preview",
  editText: "Edit",
  startSurveyText: "Kòmanse",
  commentText: "Tanpri kite yon kòmantè",
  otherItemText: "Lòt (dekri)",
  noneItemText: "Okenn",
  refuseItemText: "Refize reponn",
  dontKnowItemText: "pa konnen",
  selectAllItemText: "Chwazi Tout",
  deselectAllItemText: "Deseleksyone tout",
  progressText: "Paj {0} nan {1}",
  indexText: "{0} nan {1}",
  panelDynamicProgressText: "{0} nan {1}",
  panelDynamicTabTextFormat: "Panel {panelIndex}",
  questionsProgressText: "Reponn {0}/{1} kesyon",
  emptySurvey: "Sondaj la pa genyen okenn eleman vizib.",
  completingSurvey: "Mèsi paske w fin ranpli sondaj la",
  completingSurveyBefore: "Ou te deja ranpli sondaj sa a.",
  loadingSurvey: "Chaje sondaj...",
  placeholder: "Chwazi...",
  ratingOptionsCaption: "Chwazi...",
  buttongroupOptionsCaption: "Chwazi ...",
  value: "valè",
  requiredError: "Repons obligatwa.",
  requiredErrorInPanel: "Repons obligatwa: reponn omwen yon kesyon.",
  requiredInAllRowsError: "Repons obligatwa: reponn kesyon nan tout ranje.",
  eachRowUniqueError: "Chak ranje dwe gen yon valè inik.",
  numericError: "Valè a ta dwe nimerik.",
  minError: "Valè a pa ta dwe mwens pase {0}",
  maxError: "Valè a pa ta dwe pi gran pase {0}",
  textNoDigitsAllow: "Nimewo yo pa pèmèt.",
  textMinLength: "Tanpri antre omwen {0} karaktè (yo).",
  textMaxLength: "Tanpri antre pa plis pase {0} karaktè (yo).",
  textMinMaxLength: "Tanpri antre omwen {0} e pa plis pase {1} karaktè.",
  minRowCountError: "Tanpri ranpli omwen {0} ranje (yo).",
  minSelectError: "Tanpri chwazi omwen {0} opsyon (yo).",
  maxSelectError: "Tanpri chwazi pa plis pase {0} opsyon (yo).",
  numericMinMax: "'{0}' ta dwe omwen {1} ak pi plis {2}",
  numericMin: "'{0}' ta dwe omwen {1}",
  numericMax: "' a{0}' ta dwe pi plis {1}",
  invalidEmail: "Tanpri antre yon adrès imel ki valab.",
  invalidExpression: "Ekspresyon an: {0} ta dwe retounen 'vre'.",
  urlRequestError: "Rekèt la te retounen erè '{0}'.{1}",
  urlGetChoicesError: "Rekèt la te retounen done vid oswa pwopriyete 'chemen' a pa kòrèk",
  exceedMaxSize: "Gwosè dosye a pa ta dwe depase {0}.",
  noUploadFilesHandler: "Fichye yo pa ka telechaje. Tanpri ajoute yon moun kap okipe evènman 'onUploadFiles' la.",
  otherRequiredError: "Repons obligatwa: antre yon lòt valè.",
  uploadingFile: "Fichye w ap telechaje. Tanpri tann plizyè segonn epi eseye ankò.",
  loadingFile: "Chaje...",
  chooseFile: "Chwazi fichye (yo)...",
  noFileChosen: "Pa gen fichye chwazi",
  filePlaceholder: "Trennen epi depoze yon fichye isit la oswa klike sou bouton ki anba a pou chwazi yon fichye pou w telechaje.",
  confirmDelete: "Èske w sèten ou vle efase dosye sa a?",
  keyDuplicationError: "Valè sa a ta dwe inik.",
  addColumn: "Ajoute Kolòn",
  addRow: "Ajoute Ranje",
  removeRow: "Retire",
  noRowsText: "Pa gen ranje.",
  rowIndexTemplateTitle: "Row {rowIndex}",
  rowNameTemplateTitle: "{rowTitle}",
  addPanel: "Ajoute nouvo",
  removePanel: "Retire",
  showDetails: "Montre detay",
  hideDetails: "Kache Detay yo",
  choices_Item: "atik",
  choices_Choice: "Opsyon chwa",
  matrix_column: "Kolòn",
  matrix_row: "Ranje",
  multipletext_itemname: "tèks",
  savingData: "Rezilta yo ap sove sou sèvè a...",
  savingDataError: "Yon erè te fèt epi nou pa t 'kapab sove rezilta yo.",
  savingDataSuccess: "Rezilta yo te sove avèk siksè!",
  savingExceedSize: "Repons ou depase 64KB. Tanpri redwi gwosè fichye w la (yo) epi eseye ankò oswa kontakte pwopriyetè sondaj la.",
  saveAgainButton: "Eseye ankò",
  timerMin: "min",
  timerSec: "sec",
  timerSpentAll: "Ou te depanse {0} sou paj sa a epi {1} an total.",
  timerSpentPage: "Ou te depanse {0} sou paj sa a.",
  timerSpentSurvey: "Ou te depanse {0} an total.",
  timerLimitAll: "Ou te depanse {0} nan {1} sou paj sa a epi {2} nan {3} an total.",
  timerLimitPage: "Ou te depanse {0} nan {1} sou paj sa a.",
  timerLimitSurvey: "Ou te depanse {0} nan {1} an total.",
  clearCaption: "Klè",
  signaturePlaceHolder: "Siyen isit la",
  signaturePlaceHolderReadOnly: "Pa gen siyati",
  chooseFileCaption: "Chwazi File",
  takePhotoCaption: "Pran Foto",
  photoPlaceholder: "Klike sou bouton ki anba a pou pran yon foto ak kamera a.",
  fileOrPhotoPlaceholder: "Trennen epi depoze oswa chwazi yon dosye pou w telechaje oswa pran yon foto lè l sèvi avèk kamera a.",
  replaceFileCaption: "Ranplase fichye a",
  removeFileCaption: "Retire fichye sa a",
  booleanCheckedLabel: "Wi",
  booleanUncheckedLabel: "Non",
  confirmRemoveFile: "Èske ou sèten ou vle retire dosye sa a: {0}?",
  confirmRemoveAllFiles: "Èske w sèten ou vle retire tout fichye yo?",
  questionTitlePatternText: "Tit kesyon",
  modalCancelButtonText: "Anile",
  modalApplyButtonText: "Aplike",
  filterStringPlaceholder: "Tape pou chèche...",
  emptyMessage: "Pa gen done pou montre",
  loadingPage: "Chaje...",
  loadingData: "Chaje...",
  noEntriesText: "Pa gen okenn antre ankò.\nKlike sou bouton ki anba a pou ajoute yon nouvo antre.",
  noEntriesReadonlyText: "Pa gen antre",
  tabTitlePlaceholder: "Nouvo Panel",
  more: "Plis",
  tagboxDoneButtonCaption: "OKE",
  selectToRankEmptyRankedAreaText: "Tout chwa yo chwazi pou klasman",
  selectToRankEmptyUnrankedAreaText: "Trennen chwa isit la pou klase yo",
  ok: "OKE",
  cancel: "Anile",
  createCustomItem: "Kreye \"{0}\" atik ..."
};

setupLocale({ localeCode: "ht", strings: haitianCreoleStrings, nativeName: "Kreyòl ayisyen", englishName: "Haitian Creole" });

// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// commentText: "Please leave a comment" => "Tanpri kite yon kòmantè"
// buttongroupOptionsCaption: "Select..." => "Chwazi ..."
// rowIndexTemplateTitle: "Row {rowIndex}" => "Row {rowIndex}"
// createCustomItem: "Create \"{0}\" item..." => "Kreye \"{0}\" atik ..."